
import React from 'react';
import WaitlistSection from '../components/WaitlistSection';

const ForMakersView: React.FC = () => {
  return (
    <div className="bg-background min-h-screen">
      <section className="max-w-[1400px] mx-auto border-x border-border p-12 lg:p-24 bg-white">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <span className="text-[10px] font-mono text-secondary uppercase tracking-[0.2em] mb-4 block">Creative Hub</span>
            <h2 className="text-5xl md:text-7xl font-display tracking-tight text-primary uppercase leading-none mb-8">
              Design. <br/><span className="text-neutral-400">Then Hold.</span>
            </h2>
            <p className="text-secondary text-lg mb-8 max-w-xl">
              Turn your CAD files into physical objects in hours. No printer required. Focus on your design, we handle the logistics.
            </p>
            <div className="flex flex-wrap gap-4">
               <button className="bg-primary text-white px-8 h-14 rounded-full text-xs font-bold uppercase tracking-widest hover:bg-neutral-800 transition-all">
                  Upload Project
               </button>
               <button className="border border-border bg-white px-8 h-14 rounded-full text-xs font-bold uppercase tracking-widest hover:bg-neutral-50 transition-all">
                  Material Library
               </button>
            </div>
          </div>
          <div className="lg:col-span-5 grid grid-cols-2 gap-4">
             <div className="aspect-square bg-neutral-50 border border-border rounded-2xl p-6 flex items-center justify-center">
                <iconify-icon icon="lucide:box" class="text-4xl text-neutral-200"></iconify-icon>
             </div>
             <div className="aspect-square bg-neutral-900 border border-border rounded-2xl p-6 flex items-center justify-center">
                <iconify-icon icon="pixelarticons:cube" class="text-4xl text-white"></iconify-icon>
             </div>
             <div className="aspect-square bg-neutral-100 border border-border rounded-2xl p-6 flex items-center justify-center">
                <iconify-icon icon="lucide:sliders" class="text-4xl text-neutral-300"></iconify-icon>
             </div>
             <div className="aspect-square bg-white border border-border rounded-2xl p-6 flex items-center justify-center">
                <iconify-icon icon="lucide:zap" class="text-4xl text-primary"></iconify-icon>
             </div>
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto border-x border-border border-y bg-neutral-50 p-12 lg:p-24">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-display uppercase tracking-tight">Tools for your workflow</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {[
            { t: 'Smart Slice Analysis', d: 'Our AI analyzes your STL for printability and suggests the best orientation automatically.', i: 'lucide:cpu' },
            { t: 'Material Matcher', d: 'Not sure if you need PLA, PETG, or Resin? Use our Assistant to find the best fit.', i: 'lucide:sparkles' },
            { t: 'Rapid Prototyping', d: 'Send a batch of designs to multiple local printers simultaneously for ultra-fast iteration.', i: 'lucide:rocket' }
          ].map((item, idx) => (
            <div key={idx} className="bg-white p-8 rounded-2xl border border-border space-y-4">
              <iconify-icon icon={item.i} class="text-2xl text-primary"></iconify-icon>
              <h3 className="font-bold text-primary uppercase text-sm tracking-wide">{item.t}</h3>
              <p className="text-xs text-secondary leading-relaxed">{item.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto border-x border-border p-12 lg:p-24 bg-white">
        <div className="max-w-4xl">
          <h2 className="text-4xl font-display uppercase tracking-tight mb-8">Designer Spotlight</h2>
          <div className="grid md:grid-cols-2 gap-12">
            <div className="space-y-4">
              <div className="aspect-[4/3] bg-neutral-200 rounded-2xl overflow-hidden">
                <img src="https://picsum.photos/seed/maker1/800/600" alt="Maker 1" className="w-full h-full object-cover" />
              </div>
              <h4 className="font-bold text-primary uppercase text-sm tracking-wide">"Zetra saved my thesis."</h4>
              <p className="text-sm text-secondary">"I needed 20 unique parts in 24 hours. Zetra split the job across 5 neighbors. I had everything by dinner." — Sarah L., Product Designer</p>
            </div>
            <div className="space-y-4">
               <div className="aspect-[4/3] bg-neutral-200 rounded-2xl overflow-hidden">
                <img src="https://picsum.photos/seed/maker2/800/600" alt="Maker 2" className="w-full h-full object-cover" />
              </div>
              <h4 className="font-bold text-primary uppercase text-sm tracking-wide">"Production made easy."</h4>
              <p className="text-sm text-secondary">"I run a small brand selling customized keyboard cases. Zetra is my local manufacturing partner." — Alex K., Mechanical Engineer</p>
            </div>
          </div>
        </div>
      </section>
      <WaitlistSection />
    </div>
  );
};

export default ForMakersView;
